import Spinner from 'components/Spinner'
import { FC } from 'react'
import PageContainer from 'shared/components/PageContainer'

type Props = unknown

const Initialization: FC<Props> = () => {
  return (
    <PageContainer>
      <div className='h-full flex items-center justify-center gap-2 bg-gray-50 text-blue-500'>
        <Spinner />
        <span className='text-sm text-gray-600'>Preparing...</span>
      </div>
    </PageContainer>
  )
}

export default Initialization
